export default __webpack_public_path__ + "static/media/LogoRegister.5522586b.png";